import { AllCMSPageFields } from '@/cms/fields/mappers/common'
import { Configuration } from '@/scopes/common/domain/types/configuration'
import { MetaTitleResolver } from '@/scopes/common/domain/types/meta-data'
import { IntlShape } from 'react-intl'
import { CatalogueType } from '../../../domain/enums/CatalogueType'
import { getCatalogueTypeByPublicationCode } from '../../../domain/functions/catalogues'

interface ProductMetaTitleResolverDependencies {
  config: Configuration
  cmsFields: AllCMSPageFields
  intl: IntlShape
}

const PAGE_TITLE_TRANSLATION_KEY: Record<Exclude<CatalogueType, CatalogueType.None>, string> = {
  [CatalogueType.Summer]: 'product_default_page_title_summer',
  [CatalogueType.Winter]: 'product_default_page_title_winter',
}

function bySeasonTranslationKey(catalogueType: Exclude<CatalogueType, CatalogueType.None>) {
  return PAGE_TITLE_TRANSLATION_KEY[catalogueType]
}

function toStarString(rating: number): string {
  if (rating <= 0)
    return ''
  return '★'.repeat(Math.floor(rating)) + (rating % 1 > 0 ? '⯨' : '')
}

export function createCmsProductMetaTitleResolver({ config, cmsFields, intl }: ProductMetaTitleResolverDependencies): MetaTitleResolver {
  return {
    resolve: () => {
      const catalogueType = getCatalogueTypeByPublicationCode(config.publicationCode)

      if (catalogueType === CatalogueType.None) {
        return config.brandName
      }

      const accommodationName = cmsFields['PDP.title']
      const regionName = cmsFields['PDP.regionName']
      const countryName = cmsFields['PDP.countryName']

      if (!accommodationName || !regionName || !countryName) {
        return config.brandName
      }
      const translationKey = bySeasonTranslationKey(catalogueType)

      const rawStars = toStarString(cmsFields['PDP.rating'])
      const accommodationStars = rawStars ? ` ${rawStars}` : ''
      const brandName = config.brandName.charAt(0).toUpperCase() + config.brandName.slice(1)

      const title = intl.formatMessage(
        { id: translationKey, defaultMessage: '' },
        {
          accommodationName,
          accommodationStars,
          regionName,
          countryName,
          brandName,
        },
      )

      return title || config.brandName
    },
  }
}
